import * as React from "react"

const DocsSvg: React.FC<{ fill: string }> = ({ fill }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_311_6657"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_311_6657)">
      <path
        d="M10 12.5H3C2.72386 12.5 2.5 12.2761 2.5 12V2C2.5 1.72386 2.72386 1.5 3 1.5H7.69722C7.79594 1.5 7.89244 1.52922 7.97457 1.58397L9.22265 2.41603L10.2774 3.11916C10.4164 3.21189 10.5 3.36801 10.5 3.53518V12C10.5 12.2761 10.2761 12.5 10 12.5Z"
        stroke={fill}
      />
      <path d="M8 1.5V3C8 3.27614 8.22386 3.5 8.5 3.5H10" stroke={fill} />
      <line x1="4" y1="5.5" x2="9" y2="5.5" stroke={fill} />
      <line x1="4" y1="7.5" x2="9" y2="7.5" stroke={fill} />
      <line x1="4" y1="9.5" x2="9" y2="9.5" stroke={fill} />
      <path
        d="M11 5H11.5C12.0523 5 12.5 5.44772 12.5 6V13.5C12.5 14.0523 12.0523 14.5 11.5 14.5H5C4.44772 14.5 4 14.0523 4 13.5V12.5"
        stroke={fill}
      />
    </g>
  </svg>
)

export default DocsSvg
